import { Box, Card, CardContent, Typography } from '@mui/material'

export default function ServiceInquiriesPage() {
    return (
        <Box>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 3 }}>Service Inquiries</Typography>
            <Card>
                <CardContent sx={{ p: 4, textAlign: 'center' }}>
                    <Typography variant="body1" sx={{ color: 'grey.500' }}>
                        View and respond to customer inquiries about solar installation services.
                    </Typography>
                </CardContent>
            </Card>
        </Box>
    )
}
